'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'face-vomit';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a0';
var svgPathData = 'M544 256c0 69.9-28.1 133.3-73.5 179.5l-4.3-1.3c-17.3-5.2-30-19.6-33.3-36.9 9.7-11.4 15.1-24 15.1-37.4 0-48.6-71.6-88-160-88s-160 39.4-160 88c0 13.4 5.4 26.1 15.1 37.4-3.3 17.3-16 31.7-33.3 36.9l-4.3 1.3C60.1 389.3 32 325.9 32 256 32 114.6 146.6 0 288 0S544 114.6 544 256zM246.8 177.7l-95.6-48-16.8 27.1 45.3 34-44.2 27.6 14.7 28.3 95.6-40 10.2-4.3 0-20.2-9.2-4.6zm178-48l-95.6 48-9.2 4.6 0 20.2 10.2 4.3 95.6 40 14.7-28.3-44.2-27.6 45.3-34-16.8-27.1zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3l46.8 15.6 0 32-384 0 0-32 46.8-15.6c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceVomit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;